module.exports = __webpack_public_path__ + "images/1f84a85e2f54f5be42dbdf59a2994968.png";